export const getBookedCells = (rowData, isRetailClient, currency, isValueSelected, t) => {
  return {
    cell1: {
      cellValue:
        rowData?.[`doorOrderProductDoor${isValueSelected ? 'Value' : 'Quantity'}`] || 0,
      cellCurrency: isValueSelected ? currency : '',
      cellLabel: isValueSelected
        ? t('order.quantitiesAndBook.cnfTotalValueLabel', 'Total Door Value')
        : isRetailClient
        ? t('order.quantitiesAndBook.cnfTotalQtyLabel', 'Total Door Quantity')
        : t('order.quantitiesAndBook.cnfWhlTotalQtyLabel', 'Total Draft Quantity')
    },
    cell2: {
      cellValue:
        rowData?.[`doorOrderProductSize${isValueSelected ? 'Value' : 'Quantity'}`] || 0,
      cellCurrency: isValueSelected ? currency : '',
      cellLabel: isValueSelected
        ? t('order.quantitiesAndBook.cnfTotalSizedValueLabel', 'Total Sized Value')
        : t('order.quantitiesAndBook.cnfTotalSizedQuantityLabel', 'Total Sized Quantity')
    }
  }
}
